import React, { useEffect, useState } from 'react';
import { Oval } from 'react-loader-spinner';

const gtagEvent = 'AW-555420805/A071CJik9okYEIWZ7IgC';

export default function DownloadDocument({ onSuccess, file, post, formId }) {
  const [stop, setStop] = useState(false);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (stop) return;
    const id = setInterval(() => {
      if (typeof window === 'undefined') return;
      if (window.hbspt?.forms) {
        window.hbspt.forms.create({
          region: 'eu1',
          portalId: '25527340',
          formId: 'c167f8e4-1273-46db-97e1-9f48e9c10ef0',
          target: `#form-${formId}`,
          onFormReady: form => {
            const doc = form.querySelector(
              'input[name="document_a_telecharger__webinar__lien"]'
            );
            doc.value = file || 'test';
            doc.dispatchEvent(new Event('input', { bubbles: true }));

            const post_title = form.querySelector('input[name="post_title"]');
            post_title.value = post.title || 'test';
            post_title.dispatchEvent(new Event('input', { bubbles: true }));

            const post_url = form.querySelector('input[name="post_url"]');
            post_url.value = post.uri || 'test';
            post_url.dispatchEvent(new Event('input', { bubbles: true }));
            setLoading(false);
          },
          onFormSubmitted: (redirectUrl, submissionValues) => {
            if (window && gtagEvent)
              window.gtag('event', 'click', { send_to: gtagEvent });
            if (onSuccess) onSuccess();
          },
        });
        setStop(true);
      }
    }, 1000);
    return () => clearInterval(id);
  }, [stop]);

  return (
    <div
      id="downloadDocument"
      className="relative lg:col-span-2 flex  md:min-w-[560px] justify-center"
    >
      {loading && (
        <div className="flex justify-center w-full">
          <Oval
            height={80}
            width={80}
            color="#FF4D00"
            visible={true}
            ariaLabel="oval-loading"
            secondaryColor="#FFD8B8"
            strokeWidth={6}
            strokeWidthSecondary={6}
          />
        </div>
      )}
      <div
        id={`form-${formId}`}
        className={`w-full ${loading ? 'hidden' : ''} `}
      ></div>
    </div>
  );
}
